<template>
  <b-card-code>
    <b-card-text></b-card-text>

    <quill-editor
      :options="editorOption"
    >
      <div
        id="toolbar"
        slot="toolbar"
      >
        <!-- Add a bold button -->
        <button class="ql-bold">
          Bold
        </button>
        <button class="ql-italic">
          Italic
        </button>

        <!-- Add font size dropdown -->
        <!-- <select class="ql-size">
          <option value="small" />
          <option selected />
          <option value="large" />
          <option value="huge" />
        </select> -->

        <!-- <select class="ql-font">
          <option selected="selected" />
          <option value="serif" />
          <option value="monospace" />
        </select> -->

        <!-- Add subscript and superscript buttons -->
        <!-- <button
          class="ql-script"
          value="sub"
        />
        <button
          class="ql-script"
          value="super"
        /> -->

        <!-- You can also add your own -->
        <!-- <button
          class="w-auto btn btn-primary"
          @click="customButtonClick"
        >
          Click here
        </button> -->
      </div>
    </quill-editor>

    <template #code>
      {{ codeCustom }}
    </template>
  </b-card-code>
</template>

<script>
import { BCardText } from 'bootstrap-vue'
import BCardCode from '@core/components/b-card-code/BCardCode.vue'
import { quillEditor } from 'vue-quill-editor'
import { codeCustom } from './code'

export default {
  components: {
    quillEditor,
    BCardCode,
    BCardText,
  },
  data() {
    return {
      codeCustom,
      editorOption: {
        modules: {
          toolbar: '#toolbar',
        },
      },
    }
  },
  methods: {
    change(data) {
      // eslint-disable-next-line
      console.log(data)
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/quill.scss';
</style>
